export const STORAGE_KEYS = {
  CURRENT_LANGUAGE: 'xsiteCurrLanguage',
  VIDEO_TYPE: 'xsiteVideoType',
  LEGACY_LANGUAGE: 'xsite-language',
  LEGACY_DIRECTION: 'xsite-direction',
  GATE_MODE_PREFIX: 'xsite_gate_mode_',
  TREE_LEVEL: 'treeLevel',
  PROGRESS_PREFIX: 'xsite-',
  LOCATION_PERMISSIONS: 'locationPermissionsShown',
} as const;
